var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDuplicateBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.733,
    height: 22.733,
    viewBox: "0 0 22.733 22.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy-solid",
    d: "M9.946,0A2.844,2.844,0,0,0,7.1,2.842v9.946a2.844,2.844,0,0,0,2.842,2.842h9.946a2.844,2.844,0,0,0,2.842-2.842V2.842A2.844,2.844,0,0,0,19.892,0Zm-7.1,7.1A2.844,2.844,0,0,0,0,9.946v9.946a2.844,2.844,0,0,0,2.842,2.842h9.946a2.844,2.844,0,0,0,2.842-2.842V17.05H12.788v2.842H2.842V9.946H5.683V7.1Z",
    fill: "#022767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuplicateBlue);
export default __webpack_public_path__ + "static/media/icon-duplicate-blue.7d9cc48055043be1dfac5692595d5023.svg";
export { ForwardRef as ReactComponent };